import React from 'react'
import CustomDialog from './CustomDialog'
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { useCancelSubscription } from 'hooks/useSubscription';
import { useAuth } from 'context/AuthContext';
import { snackbarService } from 'services/snackbarService';


interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  refetch?: () => void;
  closeParent: () => void;
  provider?: string;
}

export default function CancelMembershipDialog({ open, setOpen, refetch, closeParent, provider }: Props) {
  const { user } = useAuth();
  const isAppleManaged = provider === 'APPLE';

  const { mutate: cancelMutation, isLoading } = useCancelSubscription(
    (res: any) => {
      if (res?.status_code !== 200) {
        const message = typeof res?.data === 'string' ? res.data : res?.data?.message;
        snackbarService.showSnackbar(message || 'Something went wrong cancelling your membership. Please try again.', 'error', 10000);
        return;
      }

      setOpen(false);
      closeParent();
      snackbarService.showSnackbar(
        isAppleManaged
          ? 'Your Casez access has been cancelled. Your Apple subscription must be cancelled separately in your App Store settings, or you will continue to be billed.'
          : 'Your membership has been cancelled. You’ll continue to have access until the end of your current billing period.',
        'success', 10000)
      refetch?.();

    },
    (err: any) => {
      console.log('error', err);
      snackbarService.showSnackbar('Something went wrong cancelling your membership. Please try again.', 'error', 10000);
    }
  )

  const handleConfirm = () => {
    cancelMutation(user.id);
  }


  return (
    <CustomDialog
      open={open}
      title={"Cancel membership"}
      message={
        isAppleManaged
          ? "This subscription was purchased through the App Store. Cancelling here only removes your Casez access — your Apple subscription will keep billing until you cancel it separately in your App Store settings. Continue?"
          : "Are you sure you want to cancel your membership?"
      }
      buttons={[
        <CustomButton
          key={'cancel'}
          variant='outlined'
          text='Cancel'
          textColor='error'
          onClick={() => setOpen(false)}
          height={35}
          disabled={isLoading}
        />,
        <CustomButton
          key={'yes'}
          variant='filled'
          color='error'
          text={"Yes"}
          onClick={handleConfirm}
          height={35}
          loading={isLoading}
        />,
      ]}
    />

  )
}
